export default __webpack_public_path__ + "static/media/heron.ce94bcc4.svg";